import styled from 'styled-components';

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: 600;
  color: #6c757d;
  cursor: pointer;
  &:hover {
    color: #343a40;
  }
`;

export const SectionTitle = styled.h5`
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #f8f9fa;
`;

export const Divider = styled.hr`
  margin: 1.5rem 0;
  border: 0;
  border-top: 1px solid #e9ecef;
`;

export const ProductList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 1.5rem;
`;

export const ProductItem = styled.li`
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid
    ${(props) => (props.type === 'removed' ? '#dc3545' : '#17a2b8')};
`;

export const ProductName = styled.strong`
  display: block;
  margin-bottom: 0.25rem;
  color: #212529;
`;

export const ChangeDetail = styled.div`
  margin-left: 1rem;
  margin-top: 0.5rem;
  padding: 0.35rem 0;
  font-size: 0.95rem;
  color: #6c757d;
`;

export const Badge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: 4px;
  margin-left: 0.5rem;
  background-color: ${(props) => {
    if (props.color === 'success') return '#d4edda';
    if (props.color === 'warning') return '#fff3cd';
    if (props.color === 'danger') return '#f8d7da';
    return '#e2e3e5';
  }};
  color: ${(props) => {
    if (props.color === 'success') return '#155724';
    if (props.color === 'warning') return '#856404';
    if (props.color === 'danger') return '#721c24';
    return '#383d41';
  }};
`;

export const MatrixSection = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
`;

export const MatrixContainer = styled.div`
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 6px;
`;

export const MatrixHeading = styled.h6`
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 0.5rem;
    background-color: ${(props) => (props.isOriginal ? '#dc3545' : '#28a745')};
  }
`;

export const AlertBox = styled.div`
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 6px;
  background-color: ${(props) =>
    props.type === 'info'
      ? '#cce5ff'
      : props.type === 'warning'
      ? '#fff3cd'
      : props.type === 'danger'
      ? '#f8d7da'
      : '#e2e3e5'};
  color: ${(props) =>
    props.type === 'info'
      ? '#004085'
      : props.type === 'warning'
      ? '#856404'
      : props.type === 'danger'
      ? '#721c24'
      : '#383d41'};
  border-left: 4px solid
    ${(props) =>
      props.type === 'info'
        ? '#007bff'
        : props.type === 'warning'
        ? '#ffc107'
        : props.type === 'danger'
        ? '#dc3545'
        : '#6c757d'};
`;

export const Button = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  ${(props) => {
    if (props.color === 'primary') {
      return `
        background-color: #007bff;
        border: 1px solid #007bff;
        color: white;
        &:hover {
          background-color: #0069d9;
          border-color: #0062cc;
        }
      `;
    } else if (props.color === 'secondary') {
      return `
        background-color: #6c757d;
        border: 1px solid #6c757d;
        color: white;
        &:hover {
          background-color: #5a6268;
          border-color: #545b62;
        }
      `;
    } else if (props.color === 'success') {
      return `
        background-color: #28a745;
        border: 1px solid #28a745;
        color: white;
        &:hover {
          background-color: #218838;
          border-color: #1e7e34;
        }
      `;
    } else if (props.color === 'warning') {
      return `
        background-color: #ffc107;
        border: 1px solid #ffc107;
        color: #212529;
        &:hover {
          background-color: #e0a800;
          border-color: #d39e00;
        }
      `;
    }
  }}
`;

export const HistorySection = styled.div`
  margin-top: 1.5rem;
`;

export const AlertContainer = styled.div`
  margin: 1rem 0;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  background-color: #fff8e1;
  border-left: 4px solid #ffc107;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const AlertContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffe082;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  min-width: 38px;
  color: #ff8f00;
  margin-right: 0.75rem;
  font-size: 1.1rem;
`;

export const InfoSection = styled.div`
  display: flex;
  flex: 1;
`;

export const MessageContent = styled.div`
  color: #795548;
  line-height: 1.5;
  font-size: 0.95rem;
  flex: 1;
`;

export const CountBadge = styled.span`
  display: inline-block;
  background-color: ${(props) => (props.removed ? '#f8d7da' : '#fff3cd')};
  color: ${(props) => (props.removed ? '#721c24' : '#856404')};
  padding: 0.15rem 0.5rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0 0.3rem;
`;

export const HighlightedText = styled.span`
  font-weight: 600;
  color: #e65100;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  white-space: nowrap;
  justify-content: flex-end;
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  color: #007bff;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: underline;
  transition: color 0.2s ease;

  &:hover {
    color: #0056b3;
  }
`;

export const ActionButton = styled.button`
  background-color: ${(props) =>
    props.color === 'success'
      ? '#28a745'
      : props.color === 'secondary'
      ? '#6c757d'
      : '#007bff'};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.4rem 0.75rem;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);

  &:hover {
    background-color: ${(props) =>
      props.color === 'success'
        ? '#218838'
        : props.color === 'secondary'
        ? '#5a6268'
        : '#0069d9'};
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(1px);
  }
`;
